import { computed, Ref, ref } from "vue";
import { MstSyouninGroupsService } from "@/service/MstSyouninGroupsService";
import { GroupWithMember } from "@/types/SyouninGroup";

/*
 * 初期処理
 */
export function useTeamMemberInit() {
  const loading = ref(0)
  const isError = ref(false)
  const groupWithMemberList: Ref<GroupWithMember[]> = ref([])

  const srv = new MstSyouninGroupsService()

  const getGroupMember = async() =>
  {
    loading.value++
    const res = await srv.getGroupMember()
    groupWithMemberList.value = res
    loading.value--
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  })


  return {
    isLoading,
    isError,
    getGroupMember,
    groupWithMemberList
  }
}
